import WalletConnectProvider from "@walletconnect/web3-provider";

// //  Create WalletConnect Provider
const provider = new WalletConnectProvider({
  infuraId: process.env.INFURA_ID || "08373dd0657d40ef9513b2a1029bdd8e"
});

const Wallet = {
  address: '',
  async connect(wallet) {
    if (wallet === 'walletConnect') {
      await provider.enable();
      window.web3 = new Web3(provider);
    } 
    else if(wallet === 'metamask' || window.ethereum) {
      await window.ethereum.send('eth_requestAccounts');
      window.web3 = new Web3(window.ethereum);
    }
    const accounts = await web3.eth.getAccounts();
    this.address = accounts[0];
    let balance = await web3.eth.getBalance(this.address)
    return { address: this.address, balance: balance };
  },
  async disconnected() {
    await provider.disconnect()
    await provider.on("disconnect");
  }
}
export default Wallet;
